import compact from 'lodash/compact';
import find from 'lodash/find';
import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import reject from 'lodash/reject';
import { matchPath } from 'react-router';

/**
 * returns pathMatch, which gets a page name from location.pathname
 * @param  {Array} routes   route config (see router/routeTypes.js)
 * @param  {Object} paths   path config (import * as paths from 'yourProject/router/paths')
 * @return {Function}       pathMatch
 */
export const makePathMatch = ({ routes, paths }) => {
  /**
   * using route and path config, find the page name (for analytics) using location.pathname
   * @param pathname location.pathname
   * @return page name
   */
  return (pathname: string) => {
    const matches = compact(
      reject(
        map(
          flatMap(routes, route => route.routes || route),
          route => matchPath(pathname, route)
        ),
        { path: '/', isExact: false }
      )
    );

    if (matches.length === 0) return {};

    const match = matches[0];
    const pathDefinition = find(paths, ['route', match.path]);
    const name = pathDefinition.name(match.params);

    const result = {
      name,
      params: match.params,
      path: match.path,
    };

    return result;
  };
};
